import { minuteBucketMs } from '../Store/widgetMinuteFocusStore';

export function focusedPointIndex(series, focusedMinuteMs, start = 0, end = null) {
  if (!Array.isArray(series) || focusedMinuteMs == null) return null;
  const first = Math.max(0, Math.ceil(start));
  const last = Math.min(series.length - 1, Math.floor(end ?? (series.length - 1)));
  if (first > last) return null;

  for (let index = first; index <= last; index += 1) {
    if (minuteBucketMs(series[index]?.t) === focusedMinuteMs) return index;
  }
  return null;
}
